import axios from 'axios';

import * as utils from '../utils/utils.js';

export const fetchEvent = async (event_id) => {
    var session_url = utils.backendUrl() + `/event/?event_id=${event_id}`;

    try {
        const response = await axios.get(session_url, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data.event;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

export const fetchEventActiveSession = async (event_id) => {
    var session_url =
        utils.backendUrl() + `/event_active_session/?event_id=${event_id}`;

    try {
        const response = await axios.get(session_url, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data.event;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
